import React, { useState } from 'react';
import './Home.css';

const Home = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    message: ''
  });

  const [submitted, setSubmitted] = useState(false);

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    const whatsappMessage = `
*New Project Inquiry* 🚀

*Name:* ${formData.name}
*Email:* ${formData.email}
${formData.company ? `*Company:* ${formData.company}` : ''}

*Message:*
${formData.message}

---
Sent from Software Developer India Website
    `.trim();
    
    const encodedMessage = encodeURIComponent(whatsappMessage);
    const whatsappUrl = `https://wa.me/918826360188?text=${encodedMessage}`;
    window.open(whatsappUrl, '_blank');
    
    setSubmitted(true);
    setTimeout(() => {
      setSubmitted(false);
      setFormData({ name: '', email: '', company: '', message: '' });
    }, 3000);
  };

  const reviews = [
    {
      id: 1,
      name: "Rajesh Kumar",
      title: "CEO, Tech Solutions",
      rating: 5,
      text: "Exceptional software development services. The team delivered on time and exceeded our expectations.",
      avatar: "RK"
    },
    {
      id: 2,
      name: "Priya Sharma",
      title: "Founder, Digital Agency",
      rating: 5,
      text: "Professional, dedicated, and results-driven. Highly recommend for any software development project.",
      avatar: "PS"
    },
    {
      id: 3,
      name: "Amit Patel",
      title: "Business Director",
      rating: 5,
      text: "Outstanding expertise and customer support throughout the entire development process.",
      avatar: "AP"
    }
  ];

  return (
    <div className="home">
      {/* Hero Section */}
      <section id="home" className="hero">
        <video 
          className="hero-video" 
          autoPlay 
          muted 
          loop 
          playsInline
        >
          <source src="/videos/software-development.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="hero-container">
          <div className="hero-content">
            <div className="hero-badge">
              <span>10+ YEARS | 200+ HAPPY CLIENTS</span>
            </div>
            <h1>Hire Expert Software Developers in India for Your Next Project</h1>
            <h2>Delivering Cutting-Edge Web, Mobile Apps & Enterprise Solutions Worldwide</h2>
            <p>Empowering Businesses with Scalable, Secure & Innovative Digital Solutions with Affordable, Reliable & High-Performance Web, Mobile & Custom Software Development Services.</p>
            <div className="hero-buttons">
              <button className="btn-secondary" onClick={scrollToContact}>
                Hire Developer
              </button>
              <button className="btn-primary" onClick={scrollToContact}>
                $10/Hour
              </button>
            </div>
          </div>
        </div>
      </section>
 {/* Technologies Section */}
      <section id="technologies" className="technologies">
        <div className="technologies-container">
          <div className="section-header">
            <h2>Technologies We Work With</h2>
            <p>We leverage the latest tools and frameworks to build robust, scalable solutions</p>
          </div>
          <div className="tech-categories">
            {/* Frontend Technologies */}
            <div className="tech-category">
              <h3 className="tech-category-title">Frontend Technologies</h3>
              <div className="tech-grid">
                <div className="tech-item">
                  <svg className="tech-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.5 0h21l-1.91 21.563L11.977 24l-8.564-2.438L1.5 0z" fill="#E44D26"/>
                    <path d="M12 21.968l6.95-1.933L20.09 2.5H12v19.468z" fill="#F16529"/>
                    <path d="M12 10.28H7.964l.146 1.627H12V9.137H6.178l.47 5.258H12v-4.115z" fill="#fff"/>
                    <path d="M12 16.468l-2.773-.774-.179-2.002H7.016l.353 3.948L12 20.43v-3.962z" fill="#EBEBEB"/>
                    <path d="M16.12 10.28h-4.12v1.627h2.388l-.146 1.627h-2.242v1.627l2.488.001-.236 2.628L12 20.43v-2.433l1.218.343.815-2.968H12v-1.627h3.802l-.47-5.258z" fill="#fff"/>
                  </svg>
                  <span>HTML5</span>
                </div>
                <div className="tech-item">
                  <svg className="tech-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.5 0h21l-1.91 21.563L11.977 24l-8.564-2.438L1.5 0z" fill="#264DE4"/>
                    <path d="M12 21.968l6.95-1.933L20.09 2.5H12v19.468z" fill="#2965F1"/>
                    <path d="M9.37 9.787H6.567L6.364 12H9.04l-.3 3.483L12 16.884v-1.17L9.664 15.1H9.435l.2-2.1H12V9.787H9.37z" fill="#fff"/>
                    <path d="M9.435 15.1l-.141 1.58L12 18.47v-1.276l.218-.203.24-2.89H12v-3.113h-2.933l.3 3.483-.19 2.51z" fill="#EBEBEB"/>
                    <path d="M17.133 9.787H14.5v1.627h2.388l-.146 1.627h-2.242v1.627l2.488.001-.236 2.628L14.5 19.93v-2.433l1.218.343.815-2.968H14.5v-1.627h2.302l-.47-5.258z" fill="#fff"/>
                  </svg>
                  <span>CSS3</span>
                </div>
                <div className="tech-item">
                  <svg className="tech-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="24" height="24" rx="2" fill="#F7DF1E"/>
                    <path d="M12.5 17.2c0 .8-.5 1.2-1.1 1.2-.6 0-.9-.4-.9-.8h-1.5c0 1.6 1.2 2.5 2.5 2.5 1.5 0 2.6-.9 2.6-2.3 0-1.3-.8-1.9-2.2-2.5l-.4-.2c-.8-.3-1.3-.7-1.3-1.4 0-.7.5-1.2 1.2-1.2.7 0 1.1.3 1.2 1h1.5c-.1-1.5-1.2-2.3-2.7-2.3-1.5 0-2.7 1-2.7 2.3 0 1.2.8 1.9 2.1 2.4l.5.2c.9.4 1.3.8 1.3 1.5z" fill="#000"/>
                    <path d="M18.2 17.2c0 .8-.5 1.2-1.1 1.2-.6 0-.9-.4-.9-.8h-1.5c0 1.6 1.2 2.5 2.5 2.5 1.5 0 2.6-.9 2.6-2.3 0-1.3-.8-1.9-2.2-2.5l-.4-.2c-.8-.3-1.3-.7-1.3-1.4 0-.7.5-1.2 1.2-1.2.7 0 1.1.3 1.2 1h1.5c-.1-1.5-1.2-2.3-2.7-2.3-1.5 0-2.7 1-2.7 2.3 0 1.2.8 1.9 2.1 2.4l.5.2c.9.4 1.3.8 1.3 1.5z" fill="#000"/>
                  </svg>
                  <span>JavaScript</span>
                </div>
                <div className="tech-item">
                  <svg className="tech-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14.23 12.004a2.236 2.236 0 0 1-2.235 2.236 2.236 2.236 0 0 1-2.236-2.236 2.236 2.236 0 0 1 2.235-2.236 2.236 2.236 0 0 1 2.236 2.236z" fill="#61DAFB"/>
                    <path d="M23.15 12.004c0-6.14-4.97-11.11-11.11-11.11S.93 5.864.93 12.004s4.97 11.11 11.11 11.11 11.11-4.97 11.11-11.11zm-4.08.004c0 3.87-3.14 7.01-7.03 7.01s-7.01-3.14-7.01-7.01 3.14-7.01 7.01-7.01 7.03 3.14 7.03 7.01z" fill="#61DAFB"/>
                    <path d="M12.004 2.89c-5.03 0-9.11 4.08-9.11 9.11 0 2.57 1.07 4.89 2.79 6.53l-.81.81c-1.97-1.97-3.19-4.69-3.19-7.7 0-6.03 4.89-10.92 10.92-10.92 6.03 0 10.92 4.89 10.92 10.92 0 3.01-1.22 5.73-3.19 7.7l-.81-.81c1.72-1.64 2.79-3.96 2.79-6.53.01-5.03-4.08-9.11-9.11-9.11z" fill="#61DAFB"/>
                  </svg>
                  <span>React</span>
                </div>
                <div className="tech-item">
                  <svg className="tech-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.93 12.65L4.45 2.17h3.97l2.68 5.58.08.17 2.65-5.75h3.78L12.17 12.65v6.95l-2.24.4v-7.35z" fill="#DD0031"/>
                    <path d="M15.32 2.17l-3.15 6.48v7.05l2.24-.4v-5.78l3.14-6.48h-2.23z" fill="#C3002F"/>
                  </svg>
                  <span>Angular</span>
                </div>
                <div className="tech-item">
                  <svg className="tech-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M24 1.61h-9.94L12 5.16 9.94 1.61H0l12 20.78z" fill="#41B883"/>
                    <path d="M24 1.61H9.94L12 5.16 9.94 1.61H0l12 20.78z" fill="#35495E"/>
                    <path d="M0 1.61l12 20.78 12-20.78h-9.94L12 5.16z" fill="#41B883"/>
                    <path d="M12 5.16L14.06 1.61H9.94L12 5.16z" fill="#35495E"/>
                  </svg>
                  <span>Vue.js</span>
                </div>
                <div className="tech-item">
                  <svg className="tech-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11.333 23.05c-.413.593-.667.827-1.067.827-.4 0-.6-.234-.6-.827V2.173L7.18.01h4.373c1.92 0 3.333 1.253 3.333 3.226 0 1.44-.72 2.4-2.026 3.04 1.6.453 2.693 1.813 2.693 3.627 0 2.16-1.493 3.653-3.733 3.653h-3.16v7.494h1.333l.34-.593z" fill="#3178C6"/>
                    <path d="M16.24 20.523c1.44-.747 2.267-2.027 2.267-3.867 0-1.413-.533-2.48-1.493-3.147-.907-.613-2.187-.96-3.84-.96H11.36v7.973h1.307V15.46h1.52c.907 0 1.653.187 2.053.507.453.347.68.88.68 1.573 0 .72-.267 1.253-.72 1.573-.427.32-.987.48-1.707.48H12.9v3.053h3.34v-1.623z" fill="#FFFF"/>
                    <path d="M16.24 5.73c.693-.427 1.067-1.093 1.067-1.947 0-.88-.4-1.52-1.12-1.893-.56-.293-1.307-.427-2.213-.427H11.96v4.267h2.027c.853 0 1.573-.133 2.253-.427z" fill="#FFFF"/>
                  </svg>
                  <span>TypeScript</span>
                </div>
                <div className="tech-item">
                  <svg className="tech-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2C6.477 2 2 6.477 2 12c0 4.42 2.865 8.166 6.839 9.489.5.092.682-.217.682-.482 0-.237-.008-.866-.013-1.7-2.782.603-3.369-1.342-3.369-1.342-.454-1.155-1.11-1.462-1.11-1.462-.908-.62.069-.608.069-.608 1.003.07 1.531 1.03 1.531 1.03.892 1.529 2.341 1.087 2.91.831.092-.646.35-1.086.636-1.336-2.22-.253-4.555-1.11-4.555-4.943 0-1.091.39-1.984 1.029-2.683-.103-.253-.446-1.27.098-2.647 0 0 .84-.269 2.75 1.025A9.578 9.578 0 0112 6.836c.85.004 1.705.114 2.504.336 1.909-1.294 2.747-1.025 2.747-1.025.546 1.377.203 2.394.1 2.647.64.699 1.028 1.592 1.028 2.683 0 3.842-2.339 4.687-4.566 4.935.359.309.678.919.678 1.852 0 1.336-.012 2.415-.012 2.743 0 .267.18.578.688.48C19.138 20.163 22 16.418 22 12c0-5.523-4.477-10-10-10z" fill="#f5f5f5"/>
                  </svg>
                  <span>Tailwind CSS</span>
                </div>
                <div className="tech-item">
                  <svg className="tech-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-13h2v6h-2zm0 8h2v2h-2z" fill="#563D7C"/>
                    <path d="M11 7h2v2h-2zm0 4h2v2h-2z" fill="#563D7C"/>
                  </svg>
                  <span>Bootstrap</span>
                </div>
              </div>
            </div>

            {/* Backend Technologies */}
            <div className="tech-category">
              <h3 className="tech-category-title">Backend Technologies</h3>
              <div className="tech-grid">
                <div className="tech-item">
                  <svg className="tech-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" r="11" fill="#339933"/>
                    <path d="M12 5c-1.2 0-2.2.3-3 .8 1.5.7 2.5 2.2 2.5 4v.2h3c.5-1.8 1.8-3 3.5-3v-1c-1.4-.4-3-.6-4-.8-.4-.1-.7-.2-2-.2z" fill="#fff"/>
                    <path d="M9 6.8c-.8-.5-1.8-.8-3-.8-1 0-2.6.2-4 .8v1c1.7 0 3 1.2 3.5 3h3v-.2c0-1.8 1-3.3 2.5-4z" fill="#fff"/>
                    <path d="M15 10h-3v-.2c0-1.8-1-3.3-2.5-4-1.5.7-2.5 2.2-2.5 4v.2h3v.2c0 2.2 1.5 4 3.5 4s3.5-1.8 3.5-4v-.2h-3v.2c0 1-.5 1.8-1.2 2.4.2-.5.2-1 .2-1.4v-1z" fill="#fff"/>
                  </svg>
                  <span>Node.js</span>
                </div>
                <div className="tech-item">
                  <svg className="tech-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.01 10.207h-.944v3.705c0 .528-.046.939-.14 1.23-.096.291-.27.515-.528.672-.255.156-.607.234-1.05.234-.488 0-.902-.082-1.246-.246V12.74a3.477 3.477 0 01.672.423c.196.168.335.37.423.61h-1.12V9h4.955v1.207z" fill="#777BB4"/>
                    <path d="M13.208 15.704c-.394 0-.746-.07-1.055-.208-.31-.14-.56-.332-.75-.58-.192-.25-.327-.548-.405-.892-.078-.345-.118-.725-.118-1.14 0-.414.04-.795.118-1.14.078-.345.213-.643.405-.893.19-.247.44-.44.75-.578.31-.14.661-.208 1.055-.208.394 0 .746.07 1.055.208.31.14.56.331.75.578.192.25.327.548.405.893.078.345.118.726.118 1.14 0 .415-.04.795-.118 1.14-.078.344-.213.643-.405.892-.19.248-.44.44-.75.58-.31.137-.661.208-1.055.208zm0-1.125c.247 0 .445-.068.594-.203.15-.135.248-.33.297-.586.05-.255.074-.562.074-.921 0-.36-.025-.666-.074-.922-.05-.255-.148-.45-.297-.586-.149-.135-.347-.203-.594-.203-.247 0-.445.068-.594.203-.15.136-.248.45-.297.586-.05.256-.074.563-.074.922 0 .359.025.666.074.92.05.257.148.452.297.587.149.135.347.203.594.203z" fill="#777BB4"/>
                    <path d="M18.288 9.018v6.64c0 .394-.02.754-.06 1.08-.04.325-.116.61-.228.856-.112.245-.267.442-.463.594-.197.15-.443.225-.738.225-.268 0-.498-.063-.692-.188-.194-.125-.353-.3-.478-.523-.125-.223-.218-.49-.28-.804-.06-.313-.097-.663-.104-1.05l1.125-.045c.008.268.035.502.083.703.047.2.123.37.228.508.104.14.238.208.4.208.194 0 .336-.09.424-.27.09-.18.14-.414.152-.703.012-.29.018-.61.018-.96v-.6h-.018c-.1.268-.234.494-.405.68-.17.186-.38.326-.628.42-.247.093-.527.14-.84.14-.326 0-.625-.06-.897-.18-.272-.12-.505-.293-.7-.52-.194-.228-.347-.506-.46-.836-.11-.33-.167-.707-.167-1.13 0-.423.056-.8.168-1.13.112-.33.265-.61.46-.837.195-.228.428-.4.7-.52.272-.12.572-.18.898-.18.312 0 .593.046.84.14.247.093.458.234.627.42.172.186.306.412.406.68h.018v-.72h1.08z" fill="#777BB4"/>
                  </svg>
                  <span>PHP</span>
                </div>
                <div className="tech-item">
                  <svg className="tech-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 0h24v24H0V0z" fill="#FF2D20"/>
                    <path d="M4.5 5.7c-.2 0-.3.1-.3.3v1.3c0 .2.1.3.3.3h1.2c.2 0 .3-.1.3-.3V6c0-.2-.1-.3-.3-.3H4.5zm2.7 0c-.2 0-.3.1-.3.3v1.3c0 .2.1.3.3.3H8.4c.2 0 .3-.1.3-.3V6c0-.2-.1-.3-.3-.3H7.2z" fill="#fff"/>
                    <path d="M12 5c-3.9 0-7 3.1-7 7s3.1 7 7 7 7-3.1 7-7-3.1-7-7-7zm.8 10.8c-.2.3-.6.5-1 .5-.2 0-.5-.1-.6-.3l-.2-.3c-.1-.2-.1-.5-.1-.8v-1.2c0-.5.1-.9.3-1.2.2-.3.5-.5.9-.6.3-.1.8-.2 1.3-.2h.4c.2 0 .3-.1.3-.3V6.3c0-.2-.1-.3-.3-.3h-.4c-.8 0-1.5.2-2 .6-.5.4-.9 1-1.1 1.8h-.8c-.2 0-.3.1-.3.3v.3c0 .2.1.3.3.3h.3c.1.5.3.9.6 1.3.3.4.7.6 1.2.8l.6.2c.4.1.8.2 1 .4.3.2.4.4.4.8 0 .2-.1.4-.2.6z" fill="#fff"/>
                  </svg>
                  <span>Laravel</span>
                </div>
                <div className="tech-item">
                  <svg className="tech-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2z" fill="#3776AB"/>
                    <path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm-.5 3.5c2 0 3.5 1.5 3.5 3.5v2H8V9c0-2 1.5-3.5 3.5-3.5zM8 15h3v2.5c-2 0-3.5-1.5-3.5-3.5V13h.5v2zm7-2v-2c0-2-1.5-3.5-3.5-3.5V8c2 0 3.5 1.5 3.5 3.5v2h-3v1h3z" fill="#FFD43B"/>
                    <path d="M12.5 5.5c-2 0-3.5 1.5-3.5 3.5v2h7V9c0-2-1.5-3.5-3.5-3.5zm0 1c1.4 0 2.5 1.1 2.5 2.5v1h-5V9c0-1.4 1.1-2.5 2.5-2.5z" fill="#FFD43B"/>
                  </svg>
                  <span>Python</span>
                </div>
                <div className="tech-item">
                  <svg className="tech-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2z" fill="#092E20"/>
                    <path d="M12.5 7.5l-1.5 5.5h2l-.5-5.5zm-3 2l-1.5 5.5h2l-.5-5.5zm6 0l-1.5 5.5h2l-.5-5.5zm-3 4l-1 3.5h2l-1-3.5z" fill="#fff"/>
                  </svg>
                  <span>Django</span>
                </div>
                <div className="tech-item">
                  <svg className="tech-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2z" fill="#68A063"/>
                    <path d="M11.3 8.2c-.2 0-.3.1-.3.3v5.4c0 .5-.3.8-.8.8-.2 0-.4-.1-.5-.2v-.5c.1.1.2.2.4.2.3 0 .4-.2.4-.5V8.5c0-.2-.1-.3-.3-.3h-.3z" fill="#fff"/>
                    <path d="M15.3 11.8c-.2-.2-.5-.3-.8-.3-.4 0-.7.2-.9.5-.2-.3-.5-.5-.9-.5-.3 0-.6.1-.8.3-.2.2-.3.5-.3.8 0 .6.5 1.1 1.3 1.6l.3.2.3.2c.4.3.5.6.5 1 0 .3-.1.6-.3.8-.2.2-.5.3-.8.3-.3 0-.6-.1-.8-.3-.2-.2-.3-.5-.3-.8 0-.1 0-.2.1-.3l-.3-.2c-.1.2-.2.4-.2.6 0 .5.2.9.6 1.2.4.3.9.4 1.4.4.5 0 1-.1 1.4-.4.4-.3.6-.7.6-1.2 0-.4-.2-.7-.5-1l.3-.2c.3.3.5.6.5 1 0 .3-.1.6-.3.8-.2.2-.5.3-.8.3z" fill="#fff"/>
                  </svg>
                  <span>Express.js</span>
                </div>
                <div className="tech-item">
                  <svg className="tech-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2z" fill="#336791"/>
                    <path d="M8.5 8c.3 0 .5.2.5.5v1c0 .3-.2.5-.5.5H7v2h1.5c.3 0 .5.2.5.5v1c0 .3-.2.5-.5.5H6V8h2.5zm7 0v2h-1V8.5c0-.3-.2-.5-.5-.5H12V12h1v2h-1.5c-.3 0-.5-.2-.5-.5V12h-1v1.5c0 .8.7 1.5 1.5 1.5h2c.8 0 1.5-.7 1.5-1.5v-3c0-.8-.7-1.5-1.5-1.5H15.5z" fill="#fff"/>
                  </svg>
                  <span>Java</span>
                </div>
              </div>
            </div>

            {/* Database Systems */}
            <div className="tech-category">
              <h3 className="tech-category-title">Database Systems</h3>
              <div className="tech-grid">
                <div className="tech-item">
                  <svg className="tech-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <ellipse cx="12" cy="5.5" rx="9" ry="3.5" fill="#00758F"/>
                    <path d="M3 5.5v13c0 1.93 4.03 3.5 9 3.5s9-1.57 9-3.5v-13c0 1.93-4.03 3.5-9 3.5s-9-1.57-9-3.5z" fill="#00758F"/>
                    <ellipse cx="12" cy="5.5" rx="9" ry="3.5" fill="#F29111"/>
                    <path d="M3 8v7c0 1.93 4.03 3.5 9 3.5s9-1.57 9-3.5V8c0 1.93-4.03 3.5-9 3.5S3 9.93 3 8z" fill="#F29111" opacity="0.8"/>
                  </svg>
                  <span>MySQL</span>
                </div>
                <div className="tech-item">
                  <svg className="tech-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2z" fill="#336791"/>
                    <path d="M7.5 7h2v6h-2V7zm3 0h2v6h-2V7zm3 0h2v6h-2V7zm-6 7h8v4h-8v-4z" fill="#fff"/>
                  </svg>
                  <span>PostgreSQL</span>
                </div>
                <div className="tech-item">
                  <svg className="tech-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2z" fill="#4DB33D"/>
                    <path d="M8 8c0-1.1.9-2 2-2h4c1.1 0 2 .9 2 2v8c0 1.1-.9 2-2 2h-4c-1.1 0-2-.9-2-2V8zm2.5 1c-.3 0-.5.2-.5.5s.2.5.5.5.5-.2.5-.5-.2-.5-.5-.5zm3 0c-.3 0-.5.2-.5.5s.2.5.5.5.5-.2.5-.5-.2-.5-.5-.5zm-3 2c-.3 0-.5.2-.5.5s.2.5.5.5.5-.2.5-.5-.2-.5-.5-.5zm3 0c-.3 0-.5.2-.5.5s.2.5.5.5.5-.2.5-.5-.2-.5-.5-.5zm-3 2c-.3 0-.5.2-.5.5s.2.5.5.5.5-.2.5-.5-.2-.5-.5-.5zm3 0c-.3 0-.5.2-.5.5s.2.5.5.5.5-.2.5-.5-.2-.5-.5-.5z" fill="#fff"/>
                  </svg>
                  <span>MongoDB</span>
                </div>
                <div className="tech-item">
                  <svg className="tech-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2z" fill="#DC382D"/>
                    <path d="M12 6c-3.3 0-6 2.7-6 6v4c0 .6.4 1 1 1h10c.6 0 1-.4 1-1v-4c0-3.3-2.7-6-6-6zm-2 4h4v2h-4v-2z" fill="#fff"/>
                  </svg>
                  <span>Redis</span>
                </div>
              </div>
            </div>

            {/* Mobile Technologies */}
            <div className="tech-category">
              <h3 className="tech-category-title">Mobile Technologies</h3>
              <div className="tech-grid">
                <div className="tech-item">
                  <svg className="tech-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6 18c0 .55.45 1 1 1h1v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h2v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h1c.55 0 1-.45 1-1V8H6v10zM3.5 8C2.67 8 2 8.67 2 9.5v7c0 .83.67 1.5 1.5 1.5S5 17.33 5 16.5v-7C5 8.67 4.33 8 3.5 8zm17 0c-.83 0-1.5.67-1.5 1.5v7c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5zm-4.97-5.84l1.3-1.3c.2-.2.2-.51 0-.71-.2-.2-.51-.2-.71 0l-1.48 1.48A5.84 5.84 0 0012 1c-.96 0-1.86.23-2.66.63L7.85.15c-.2-.2-.51-.2-.71 0-.2.2-.2.51 0 .71l1.31 1.31A5.983 5.983 0 006 7h12c0-2.1-1.1-3.9-2.81-4.96l.34-.88zM10 5H9V4h1v1zm5 0h-1V4h1v1z" fill="#3DDC84"/>
                  </svg>
                  <span>Android</span>
                </div>
                <div className="tech-item">
                  <svg className="tech-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2z" fill="#02569B"/>
                    <path d="M12 6L6 18h3l1.5-3.5h3L15 18h3L12 6zm-1.5 8.5L12 9l1.5 5.5h-3z" fill="#fff"/>
                  </svg>
                  <span>Flutter</span>
                </div>
                <div className="tech-item">
                  <svg className="tech-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14.23 12.004a2.236 2.236 0 0 1-2.235 2.236 2.236 2.236 0 0 1-2.236-2.236 2.236 2.236 0 0 1 2.235-2.236 2.236 2.236 0 0 1 2.236 2.236z" fill="#61DAFB"/>
                    <path d="M23.15 12.004c0-6.14-4.97-11.11-11.11-11.11S.93 5.864.93 12.004s4.97 11.11 11.11 11.11 11.11-4.97 11.11-11.11zm-4.08.004c0 3.87-3.14 7.01-7.03 7.01s-7.01-3.14-7.01-7.01 3.14-7.01 7.01-7.01 7.03 3.14 7.03 7.01z" fill="#61DAFB"/>
                    <path d="M12.004 2.89c-5.03 0-9.11 4.08-9.11 9.11 0 2.57 1.07 4.89 2.79 6.53l-.81.81c-1.97-1.97-3.19-4.69-3.19-7.7 0-6.03 4.89-10.92 10.92-10.92 6.03 0 10.92 4.89 10.92 10.92 0 3.01-1.22 5.73-3.19 7.7l-.81-.81c1.72-1.64 2.79-3.96 2.79-6.53.01-5.03-4.08-9.11-9.11-9.11z" fill="#61DAFB"/>
                  </svg>
                  <span>React Native</span>
                </div>
                <div className="tech-item">
                  <svg className="tech-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2z" fill="#512BD4"/>
                    <path d="M12 6c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2s2-.9 2-2V8c0-1.1-.9-2-2-2zm-4 4c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2s2-.9 2-2v-4c0-1.1-.9-2-2-2zm8 0c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2s2-.9 2-2v-4c0-1.1-.9-2-2-2z" fill="#fff"/>
                  </svg>
                  <span>.NET MAUI</span>
                </div>
                <div className="tech-item">
                  <svg className="tech-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2z" fill="#A259FF"/>
                    <path d="M12 6c-3.3 0-6 2.7-6 6s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6zm-2 4h4v2h-4v-2zm0 3h4v2h-4v-2z" fill="#fff"/>
                  </svg>
                  <span>Figma</span>
                </div>
              </div>
            </div>

            {/* Cloud & Hosting - Hidden for now
            <div className="tech-category">
              <h3 className="tech-category-title">Cloud & Hosting</h3>
              <div className="tech-grid">
                <div className="tech-item">
                  <svg className="tech-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2z" fill="#FF9900"/>
                    <path d="M8 10c0-2.2 1.8-4 4-4s4 1.8 4 4c0 .7-.2 1.4-.5 2h-7c-.3-.6-.5-1.3-.5-2zm-2 4h12c.6 0 1 .4 1 1s-.4 1-1 1H6c-.6 0-1-.4-1-1s.4-1 1-1zm1 3h10c.6 0 1 .4 1 1s-.4 1-1 1H7c-.6 0-1-.4-1-1s.4-1 1-1z" fill="#fff"/>
                  </svg>
                  <span>AWS</span>
                </div>
                <div className="tech-item">
                  <svg className="tech-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2z" fill="#4285F4"/>
                    <path d="M12 6c-3.3 0-6 2.7-6 6s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6zm0 2c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm-3 6c0-1.7 1.3-3 3-3s3 1.3 3 3H9z" fill="#fff"/>
                  </svg>
                  <span>Google Cloud</span>
                </div>
                <div className="tech-item">
                  <svg className="tech-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2z" fill="#00A4EF"/>
                    <path d="M6 6h5v5H6V6zm7 0h5v5h-5V6zm-7 7h5v5H6v-5zm7 0h5v5h-5v-5z" fill="#fff"/>
                  </svg>
                  <span>Azure</span>
                </div>
                <div className="tech-item">
                  <svg className="tech-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2z" fill="#2496ED"/>
                    <path d="M12 6c-1.1 0-2 .9-2 2h4c0-1.1-.9-2-2-2zm-4 2c0-1.1-.9-2-2-2s-2 .9-2 2h4zm8 0c0-1.1.9-2 2-2s2 .9 2 2h-4zm-8 3c0-1.1-.9-2-2-2s-2 .9-2 2h4zm4 0c0-1.1-.9-2-2-2s-2 .9-2 2h4zm4 0c0-1.1.9-2 2-2s2 .9 2 2h-4zm-8 3c0-1.1-.9-2-2-2s-2 .9-2 2h4zm4 0c0-1.1-.9-2-2-2s-2 .9-2 2h4zm-4 3h8v2H8v-2z" fill="#fff"/>
                  </svg>
                  <span>Docker</span>
                </div>
                <div className="tech-item">
                  <svg className="tech-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2z" fill="#326CE5"/>
                    <path d="M12 6c-3.3 0-6 2.7-6 6s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6zm0 2c1.1 0 2 .9 2 2h-4c0-1.1.9-2 2-2zm-3 3h6v2H9v-2zm0 3h6v2H9v-2z" fill="#fff"/>
                  </svg>
                  <span>Kubernetes</span>
                </div>
                <div className="tech-item">
                  <svg className="tech-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2z" fill="#FF4500"/>
                    <path d="M12 6l-4 4h3v4h2v-4h3l-4-4z" fill="#fff"/>
                  </svg>
                  <span>Vercel</span>
                </div>
              </div>
            </div>
            */}
          </div>
        </div>
      </section>

    
      {/* Client Logos Section */}
      <section className="client-logos">
        <div className="client-logos-container">
          <div className="section-header">
            <h2>Trusted by Global Brands</h2>
            <p>We work with leading companies to deliver consistent, growth-focused digital results</p>
          </div>
          
          <div className="logos-slider">
            <div className="logos-track">
              {[
                { name: 'TechCorp', logo: '🏢' },
                { name: 'InnovateLabs', logo: '💡' },
                { name: 'DataSystems', logo: '📊' },
                { name: 'CloudFirst', logo: '☁️' },
                { name: 'FinTech Pro', logo: '💰' },
                { name: 'HealthCare Plus', logo: '🏥' },
                { name: 'EduTech', logo: '📚' },
                { name: 'LogisTech', logo: '🚚' },
                { name: 'RetailMax', logo: '🛒' },
                { name: 'TravelHub', logo: '✈️' },
                { name: 'FoodChain', logo: '🍽️' },
                { name: 'AutoDrive', logo: '🚗' },
              ].map((client, index) => (
                <div key={`client-${index}`} className="logo-item">
                  <span className="logo-icon">{client.logo}</span>
                  <span className="logo-name">{client.name}</span>
                </div>
              ))}
              {[
                { name: 'TechCorp', logo: '🏢' },
                { name: 'InnovateLabs', logo: '💡' },
                { name: 'DataSystems', logo: '📊' },
                { name: 'CloudFirst', logo: '☁️' },
                { name: 'FinTech Pro', logo: '💰' },
                { name: 'HealthCare Plus', logo: '🏥' },
                { name: 'EduTech', logo: '📚' },
                { name: 'LogisTech', logo: '🚚' },
                { name: 'RetailMax', logo: '🛒' },
                { name: 'TravelHub', logo: '✈️' },
                { name: 'FoodChain', logo: '🍽️' },
                { name: 'AutoDrive', logo: '🚗' },
              ].map((client, index) => (
                <div key={`client-duplicate-${index}`} className="logo-item">
                  <span className="logo-icon">{client.logo}</span>
                  <span className="logo-name">{client.name}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="logos-slider logos-slider-reverse">
            <div className="logos-track">
              {[
                { name: 'TechCorp', logo: '🏢' },
                { name: 'InnovateLabs', logo: '💡' },
                { name: 'DataSystems', logo: '📊' },
                { name: 'CloudFirst', logo: '☁️' },
                { name: 'FinTech Pro', logo: '💰' },
                { name: 'HealthCare Plus', logo: '🏥' },
                { name: 'EduTech', logo: '📚' },
                { name: 'LogisTech', logo: '🚚' },
                { name: 'RetailMax', logo: '🛒' },
                { name: 'TravelHub', logo: '✈️' },
                { name: 'FoodChain', logo: '🍽️' },
                { name: 'AutoDrive', logo: '🚗' },
              ].map((client, index) => (
                <div key={`client-reverse-${index}`} className="logo-item">
                  <span className="logo-icon">{client.logo}</span>
                  <span className="logo-name">{client.name}</span>
                </div>
              ))}
              {[
                { name: 'TechCorp', logo: '🏢' },
                { name: 'InnovateLabs', logo: '💡' },
                { name: 'DataSystems', logo: '📊' },
                { name: 'CloudFirst', logo: '☁️' },
                { name: 'FinTech Pro', logo: '💰' },
                { name: 'HealthCare Plus', logo: '🏥' },
                { name: 'EduTech', logo: '📚' },
                { name: 'LogisTech', logo: '🚚' },
                { name: 'RetailMax', logo: '🛒' },
                { name: 'TravelHub', logo: '✈️' },
                { name: 'FoodChain', logo: '🍽️' },
                { name: 'AutoDrive', logo: '🚗' },
              ].map((client, index) => (
                <div key={`client-reverse-duplicate-${index}`} className="logo-item">
                  <span className="logo-icon">{client.logo}</span>
                  <span className="logo-name">{client.name}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

     
      {/* Features Section */}
      <section id="features" className="features">
        <div className="features-container">
          <div className="section-header">
            <h2>Our Software Development Expertise</h2>
            <p>Comprehensive software solutions across multiple industries</p>
          </div>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-header">
                <div className="feature-icon">🏥</div>
                <h3>Healthcare Software</h3>
              </div>
              <p>HIPAA-compliant EMR, EHR, telemedicine, and patient management systems</p>
            </div>
            <div className="feature-card">
              <div className="feature-header">
                <div className="feature-icon">💳</div>
                <h3>FinTech Solutions</h3>
              </div>
              <p>Banking apps, payment gateways, trading platforms, and financial software</p>
            </div>
            <div className="feature-card">
              <div className="feature-header">
                <div className="feature-icon">🛒</div>
                <h3>E-Commerce Platforms</h3>
              </div>
              <p>Custom online stores, marketplace solutions, and inventory management</p>
            </div>
            <div className="feature-card">
              <div className="feature-header">
                <div className="feature-icon">📚</div>
                <h3>EdTech Applications</h3>
              </div>
              <p>LMS, e-learning platforms, student management, and virtual classrooms</p>
            </div>
            <div className="feature-card">
              <div className="feature-header">
                <div className="feature-icon">🚚</div>
                <h3>Logistics & Supply Chain</h3>
              </div>
              <p>Fleet management, warehouse systems, and delivery tracking software</p>
            </div>
            <div className="feature-card">
              <div className="feature-header">
                <div className="feature-icon">🏢</div>
                <h3>Enterprise CRM/ERP</h3>
              </div>
              <p>Custom business management, workflow automation, and CRM solutions</p>
            </div>
            <div className="feature-card">
              <div className="feature-header">
                <div className="feature-icon">📊</div>
                <h3>AI & Data Analytics</h3>
              </div>
              <p>Predictive analytics, machine learning, and business intelligence dashboards</p>
            </div>
            <div className="feature-card">
              <div className="feature-header">
                <div className="feature-icon">🔒</div>
                <h3>Cybersecurity</h3>
              </div>
              <p>Security monitoring, risk assessment, and compliance for enterprise applications</p>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="services">
        <div className="services-container">
          <div className="section-header">
            <h2>Core Software Development Services</h2>
            <p>End-to-end software development tailored to your business goals</p>
          </div>
          <div className="services-grid">
            <div className="service-card">
              <div className="service-header">
                <div className="service-icon">⚙</div>
                <h3>Custom Software Development</h3>
              </div>
              <p>Tailored enterprise software solutions designed specifically for your business processes and workflows.</p>
              <ul className="service-features">
                <li>✓ Enterprise Applications</li>
                <li>✓ Business Process Automation</li>
                <li>✓ Legacy System Modernization</li>
                <li>✓ Database Design & Development</li>
              </ul>
            </div>

            <div className="service-card featured">
              <div className="popular-badge">Most Popular</div>
              <div className="service-header">
                <div className="service-icon">🌐</div>
                <h3>SaaS Development</h3>
              </div>
              <p>Build scalable cloud-native SaaS products with multi-tenancy, subscription management, and analytics.</p>
              <ul className="service-features">
                <li>✓ Multi-Tenant Architecture</li>
                <li>✓ Subscription & Billing</li>
                <li>✓ Cloud Infrastructure Setup</li>
                <li>✓ API-First Development</li>
              </ul>
            </div>

            <div className="service-card">
              <div className="service-header">
                <div className="service-icon">📱</div>
                <h3>Mobile App Development</h3>
              </div>
              <p>Native and cross-platform mobile applications with seamless user experiences for iOS and Android.</p>
              <ul className="service-features">
                <li>✓ Flutter & React Native</li>
                <li>✓ Native iOS (Swift) & Android (Kotlin)</li>
                <li>✓ Offline-First Apps</li>
                <li>✓ App Store Optimization</li>
              </ul>
            </div>

            <div className="service-card">
              <div className="service-header">
                <div className="service-icon">🔗</div>
                <h3>API & Integration Services</h3>
              </div>
              <p>RESTful APIs, microservices architecture, and third-party system integrations.</p>
              <ul className="service-features">
                <li>✓ RESTful & GraphQL APIs</li>
                <li>✓ Microservices Architecture</li>
                <li>✓ Third-Party Integrations</li>
                <li>✓ API Security & Documentation</li>
              </ul>
            </div>

            <div className="service-card">
              <div className="service-header">
                <div className="service-icon">🌐</div>
                <h3>Web Application Development</h3>
              </div>
              <p>Full-stack web applications using React, Angular, Vue.js, Node.js, Python, and modern frameworks.</p>
              <ul className="service-features">
                <li>✓ Progressive Web Apps (PWA)</li>
                <li>✓ Single Page Applications (SPA)</li>
                <li>✓ Real-time Applications</li>
                <li>✓ E-commerce Development</li>
              </ul>
            </div>

            <div className="service-card">
              <div className="service-header">
                <div className="service-icon">☁️</div>
                <h3>Cloud & DevOps Solutions</h3>
              </div>
              <p>Cloud migration, infrastructure setup, CI/CD pipelines, and automated deployment strategies.</p>
              <ul className="service-features">
                <li>✓ AWS, Azure, Google Cloud</li>
                <li>✓ Docker & Kubernetes</li>
                <li>✓ CI/CD Pipeline Setup</li>
                <li>✓ Infrastructure as Code</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
  {/* Reviews Section */}
      <section id="reviews" className="reviews">
        <div className="reviews-container">
          <div className="reviews-header">
            <h2 className="reviews-title">
              Trusted by <span className="text-accent-yellow">200+</span> Happy Clients
            </h2>
            <p className="reviews-subtitle">
              Our clients consistently rate us <span className="text-accent-cyan">5 stars</span> for quality and service
            </p>
          </div>

          <div className="reviews-grid">
            {reviews.map((review) => (
              <div key={review.id} className="review-card">
                <div className="review-rating">
                  {[...Array(review.rating)].map((_, i) => (
                    <span key={i} className="star">★</span>
                  ))}
                </div>
                <p className="review-text">"{review.text}"</p>
                <div className="review-author">
                  <div className="author-avatar">{review.avatar}</div>
                  <div className="author-info">
                    <h4 className="author-name">{review.name}</h4>
                    <p className="author-title">{review.title}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="reviews-stats">
            <div className="stat-item">
              <h3 className="stat-number">200+</h3>
              <p className="stat-label">Happy Clients</p>
            </div>
            <div className="stat-item">
              <h3 className="stat-number">4.8★</h3>
              <p className="stat-label">Average Rating</p>
            </div>
            <div className="stat-item">
              <h3 className="stat-number">100%</h3>
              <p className="stat-label">Satisfaction Rate</p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="contact">
        <div className="contact-container">
          <div className="contact-content">
            <div className="contact-info">
              <div className="contact-header-content">
                <h2>Get In Touch With Us</h2>
                <p>Ready to start your software development project? Connect with our team to discuss your requirements and explore how we can help bring your vision to life.</p>
              </div>

              <div className="contact-details">
                <div className="contact-item">
                  <div className="contact-icon">📧</div>
                  <div>
                    <h4>Email Us</h4>
                    <p>contact@softwaredeveloperindia.com</p>
                  </div>
                </div>
                <div className="contact-item">
                  <div className="contact-icon">📱</div>
                  <div>
                    <h4>Call Us</h4>
                    <p>+91 88263 60188</p>
                  </div>
                </div>
                <div className="contact-item">
                  <div className="contact-icon">📍</div>
                  <div>
                    <h4>Visit Us</h4>
                    <p>Noida, India</p>
                  </div>
                </div>
              </div>

              <div className="social-links">
                <a href="https://linkedin.com" className="social-icon" target="_blank" rel="noopener noreferrer">LinkedIn</a>
                <a href="https://twitter.com" className="social-icon" target="_blank" rel="noopener noreferrer">Twitter</a>
                <a href="https://github.com" className="social-icon" target="_blank" rel="noopener noreferrer">GitHub</a>
              </div>
            </div>

            <div className="contact-form-wrapper">
              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="name">Name</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="Your name"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="email">Email</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="your@email.com"
                      required
                    />
                  </div>
                </div>
                <div className="form-group">
                  <label htmlFor="company">Company (Optional)</label>
                  <input
                    type="text"
                    id="company"
                    name="company"
                    value={formData.company}
                    onChange={handleChange}
                    placeholder="Your company name"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="message">Message</label>
                  <textarea
                    id="message"
                    name="message"
                    rows="5"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Tell us about your project..."
                    required
                  ></textarea>
                </div>
                <button type="submit" className="submit-btn" disabled={submitted}>
                  {submitted ? '✓ Message Sent!' : 'Send Message →'}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Footer Section */}
      <footer className="footer">
        <div className="footer-container">
          <div className="footer-bottom">
            <p>&copy; {new Date().getFullYear()} Software Developer India. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Home;
